<template>
  <div>
    <ag-grid-vue
        v-if="columnDefs.length > 0"
        class="ag-theme-balham"
        :gridOptions="gridOptions"
        @grid-ready="onGridReady"
        :columnDefs="columnDefs"
        :defaultColDef="defaultColDef"
        :groupUseEntireRow="false"
        :pagination="paginate"
        :paginationPageSize="paginationSize"
        :domLayout="'autoHeight'"
        :sideBar="showSidebar"
        :rowData="items">
    </ag-grid-vue>
  </div>
</template>

<script>
  import {AgGridVue} from "ag-grid-vue";
  export default {
    components: {
      AgGridVue,
    },
    props: {
      items: {
        type: Array,
        default: []
      },
      fields: {
        default: []
      },
      paginate: {
        type: Boolean,
        default: false
      },
      paginationSize: {
        type: Number,
        default: 25
      },
      showSidebar: {
        type: Boolean,
        default: false
      },
      pivotMode: {
        type: Boolean,
        default: false
      },
      fieldsDefinition: {
        type: Array,
        default: []
      },
      location: {
        type: String,
        default: ''
      }

    },
    data() {
      return {
        gridOptions: {},
        defaultColDef: {
          filter: true,
          sortable: true,
          rowDraw: true,
          enableValue: true,
          enableRowGroup: true,
          enablePivot: true,
          resizable: true,
        }
      }
    },
    computed: {
      columnDefs() {
        const columsDefinition = [];
          if (this.fields) {
            this.fields.forEach(key => {
              if (key !== 'ag-Grid-AutoColumn') {
                columsDefinition.push(
                  {
                    headerName: key,
                    field: key,
                  }
                )
              }
            });
          }
        return columsDefinition;
      },
      editing() {
        return this.$route.name !== 'report.show'
      }
    },
    mounted() {
      if (this.location !== 'create') {
        if (this.pivotMode) {
          this.gridOptions.columnApi.setPivotMode(this.pivotMode);
        }

        if (this.fieldsDefinition) {
          this.gridOptions.columnApi.setColumnState(this.fieldsDefinition);
        }
      }
    },
    methods: {
      exportData(type) {
        let params = {
          fileName: 'table',
          columnSeparator: ','
        };
        if (type === 'csv') {
          this.gridOptions.api.exportDataAsCsv(params);
        }
        else if (type === 'xls') {
          this.gridOptions.api.exportDataAsExcel(params);
        }
      },
      onGridReady(params) {
        params.api.addAggFunc("sum", mySum);
        params.api.addAggFunc("avg", myAvg);
        this.gridOptions.columnApi.setColumnState(this.fieldsDefinition);
      },
    },
  }
  function mySum(values) {
    let result = 0;
    values.forEach(function(value) {
      if (typeof value === "number") {
        result += value;
      } else {
        result += parseFloat(value);
      }
    });
    return result;
  }
  function myAvg(values) {
    let sum = 0;
    let count = 0;
    values.forEach(function(value) {
      let groupNode = value !== null && value !== undefined && typeof value === "object";
      if (groupNode) {
        sum += value.avg * value.count;
        count += value.count;
      } else {
        if (typeof value === "number") {
          sum += value;
          count++;
        }
        if (typeof value === "string") {
          sum += parseFloat(value);
          count++;
        }
      }
    });
    let avg = 0;
    if (count !== 0) {
      avg = sum / count;
    }
    let result = {
      count: count,
      avg: avg,
      toString: function() {
        return avg.toString();
      }
    };
    return result;
  }
</script>
